import React from "react";
import { Button } from "semantic-ui-react";
import Segment from "semantic-ui-react/dist/commonjs/elements/Segment";
import Container from "semantic-ui-react/dist/commonjs/elements/Container";
import Divider from "semantic-ui-react/dist/commonjs/elements/Divider";
import Icon from "semantic-ui-react/dist/commonjs/elements/Icon";
import Label from "semantic-ui-react/dist/commonjs/elements/Label";

const Footer = class extends React.Component {
  render() {
    return (
      <Segment
        vertical
      >
        <Container textAlign="center">
          <h1 style={{ color: "black" }}>Follow Us</h1>
          <Divider inverted />
          <a href="https://www.facebook.com/gmgt.live/">
            <Button circular as="div" labelPosition="right">
              <Button circular color="facebook">
                <Icon name="facebook" />
                Like Us
              </Button>
              <Label basic circular>
                GMGT
              </Label>
            </Button>
          </a>
          <a href="https://instagram.com/gmgt.live?igshid=1m4ysfa1uxnhn">
            <Button circular as="div" labelPosition="right">
              <Button circular color="instagram">
                <Icon name="instagram" />
                Gram Us
              </Button>
              <Label basic circular>
                GMGT
              </Label>
            </Button>
          </a>
          <a href="https://wa.me/13473095254">
            <Button circular as="div" labelPosition="right">
              <Button circular color="green">
                <Icon name="whatsapp" />
                Text Us
              </Button>
              <Label basic color="green" circular>
                GMGT
              </Label>
            </Button>
          </a>
          <a href="https://www.mixcloud.com/GMGTLive1/">
            <Button circular as="div" labelPosition="right">
              <Button circular color="purple">
                <Icon name="mixcloud" />
                Watch Us
              </Button>
              <Label basic color="purple" circular>
                GMGT
              </Label>
            </Button>
          </a>
          <a href="https://www.youtube.com/channel/UCVnZLZ8724CHhI6I4xwP21w">
            <Button circular as="div" labelPosition="right">
              <Button circular color="youtube">
                <Icon name="youtube" />
                Subscribe Us
              </Button>
              <Label basic circular>
                GMGT
              </Label>
            </Button>
          </a>
          <a href="https://twitter.com/gmgt_live">
            <Button circular as="div" labelPosition="right">
              <Button circular color="twitter">
                <Icon name="twitter" />
                Follow Us
              </Button>
              <Label basic circular>
                @GMGT
              </Label>
            </Button>
          </a>
        </Container>
      </Segment>
    );
  }
};

export default Footer;
